module.exports = __webpack_public_path__ + "73ccd9104311c973993679bbbe5f3ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grey-phone.png
// module id = 238
// module chunks = 1